import { cn } from '@utils/cn';
import { Text, Button } from '@ui-component-library';

export function SummaryEditButton({ step, onEditStep, disabled }) {
  return (
    <div className="mt-2 flex justify-end border-t border-charcoal-200/80 pt-3">
      <Button
        tw
        type="button"
        variant="secondary"
        size="small"
        onClick={() => onEditStep?.(step)}
        disabled={disabled}
      >
        Redigera
      </Button>
    </div>
  );
}

export function SummaryRow({ label, value, valueClassName, info }) {
  return (
    <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-4">
      <div className="flex min-w-[10rem] flex-wrap items-center gap-2">
        <Text variant="text-sm/leading-normal/medium" className="text-charcoal-700">
          {label}
        </Text>
        {info}
      </div>
      <Text
        variant="text-sm/leading-normal/normal"
        className={cn('text-charcoal-900', valueClassName)}
      >
        {value}
      </Text>
    </div>
  );
}
